
import './App.css';
import React from "react";
import {BrowserRouter as Router, Route, Routes, Link} from 'react-router-dom';
import Home from './components/Home';
import NoteApp from './components/NoteApp';
import NoteAppID from './components/NoteAppID';
import NotePage from './components/NoteDisplay';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/about1" element={<NoteApp />}></Route>
        <Route path="/about2" element={<NoteAppID />}></Route>
        <Route path="/note" element={<NotePage />} />  {/* Note page with the note content */}
      </Routes>
    </Router>
  );
}

export default App;
